/* eslint-disable no-multi-assign */
/* eslint-disable no-shadow */
import { GetErrorMessage } from "@/constants/errors-http/HTTPHandler";
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import i18n from "@/i18n";
import {
	GET_STRATIFIED_TREND_SIGNALS,
	GET_STRATIFIED_TREND_SIGNALS_ERROR,
	GET_STRATIFIED_TREND_SIGNALS_SUCCESS,
	GET_TREND_SIGNALS,
	GET_TREND_SIGNALS_ERROR,
	GET_TREND_SIGNALS_SUCCESS,
	RESET_TREND_CHART_PARAMETERS,
} from "@/stores/actions/TrendSignal";
import { http } from "@/api";

const state = {
	isSignalBased:      false,
	selectedBaseSignal: "",
	selectedSignals:    [],
	selectedPeriod:     i18n.t("PeriodSelector.Last7Days"),
	data:               [],
	status:             FetchStatus.Init,
	error:              {},
	errorHead:          "",
	snackbar:           false,
	errorTexT:          "",
};

const Qs = require("qs");

const actions = {

	/**
	 * @summary Dispara o commit para reiniciar parâmetros e dados de tendências.
	 * @type {void}
	 */
	[RESET_TREND_CHART_PARAMETERS]: ({ commit }) =>
	{
		commit(RESET_TREND_CHART_PARAMETERS);
	},

	/**
	 * @summary Realiza a requisição http no back-end dos sinais de tendência.
	 * E commita os valores caso obtenha SUCCESSo: Ele commita que obteve SUCCESSo e commita os valores obtidos.
	 * Caso obtenha um erro: Ele commita o erro em erros.
	 * @type {void}
	 * @param {Object} parameters Parameters é um objeto que contem Array de trendSettingsIds, data de inicio da pesquisa
	 * e data final da pesquisa.
	 */
	[GET_TREND_SIGNALS]: ({ commit }, parameters) =>
	{
		commit(GET_TREND_SIGNALS);
		http.get("/TrendSignalRecords", {
			params:           parameters,
			headers:          { dateTimeFormat: parameters.dateTimeFormat },
			paramsSerializer: params => Qs.stringify(params, { allowDots: true, arrayFormat: "indices" }),
		})
			.then((resp) =>
			{
				if (resp.status !== 200)
				{
					commit(GET_TREND_SIGNALS_ERROR, resp.status);
				}
				else
				{
					commit(GET_TREND_SIGNALS_SUCCESS, resp);
				}
			})
			.catch((error) =>
			{
				commit(GET_TREND_SIGNALS_ERROR, error.response.status);
			});
	},

	/**
	 * @type {void}
	 * @summary Chamada da função de sinais de têndencia estratificados no back-end;
	 * E faz commit nas mutações dos sinais de tendência.
	 * @param {Object} Parameters - parametros do backend;
	 */
	[GET_STRATIFIED_TREND_SIGNALS]: ({ commit }, parameters) =>
	{
		commit(GET_STRATIFIED_TREND_SIGNALS);
		http.get("/TrendSignalRecords/Stratification", {
			params:           parameters.stratification,
			headers:          { dateTimeFormat: "dd/MM/yyyy HH:mm:ss" },
			paramsSerializer: params => Qs.stringify(params, { allowDots: true, arrayFormat: "indices" }),
		})
			.then((resp) =>
			{
				if (resp.status !== 200)
				{
					commit(GET_STRATIFIED_TREND_SIGNALS_ERROR, resp.status);
				}
				else
				{
					commit(GET_STRATIFIED_TREND_SIGNALS_SUCCESS, resp);
				}
			})
			.catch((error) =>
			{
				commit(GET_STRATIFIED_TREND_SIGNALS_ERROR, error.response.status);
			});
	},
};

const mutations = {
	[GET_TREND_SIGNALS]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[RESET_TREND_CHART_PARAMETERS]: (state) =>
	{
		state.isSignalBased = false;
		state.selectedBaseSignal = "";
		state.selectedSignals = [];
		state.selectedPeriod = i18n.t("PeriodSelector.Last7Days");
		state.data = [];
		state.status = FetchStatus.Init;
	},
	[GET_TREND_SIGNALS_SUCCESS]: (state, resp) =>
	{
		state.data = resp.data;
		state.status = FetchStatus.Loaded;
	},
	[GET_TREND_SIGNALS_ERROR]: (state, error) =>
	{
		state.error = error;
		state.errorTexT = GetErrorMessage(error);
		state.status = FetchStatus.Error;
		state.snackbar = true;
	},
	[GET_STRATIFIED_TREND_SIGNALS]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_STRATIFIED_TREND_SIGNALS_SUCCESS]: (state, resp) =>
	{
		state.data = resp.data;
		state.status = FetchStatus.Loaded;
	},
	[GET_STRATIFIED_TREND_SIGNALS_ERROR]: (state, error) =>
	{
		state.error = error;
		state.errorTexT = GetErrorMessage(error);
		state.status = FetchStatus.Error;
		state.snackbar = true;
	},
};

export default {
	state,
	actions,
	mutations,
};
